<template>
	<td class="py-4 text-break lh-xs position-relative" :colspan="colspan" width="45">
		<div class="text-muted text-lg" v-tooltip:left="info" v-if="info"><i class="bi bi-info-circle"></i></div>
		<a href="javascript:void(0);" class="stretched-link" @click="select" v-if="hasSelect"></a>
	</td>
</template>

<script>
	import { getCurrentInstance } from 'vue';

	export default {
		emits: ['select'],
		props: {
			info: String,
			header: String,
			subtext: String,
			colspan: {
				type: Number,
				defaul: 1
			}
		},
		setup(props, { emit }) {
			const hasSelect = typeof getCurrentInstance()?.vnode.props?.onSelect === 'function';
			const select = () => emit('select');

			return { hasSelect, select };
		}
	}
</script>